import { Route, Routes } from "react-router-dom";
import { Routes as FleetRegistrationRoutes } from "./routes";
import { FleetRegistrationRouterCmp } from "./types";
import { RegistrationExpirySearchPage } from "../pages/RegistrationExpirySearchPage";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FleetRegistrationRouter: FleetRegistrationRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route
          path={RegistrationExpirySearchPage.route}
          element={<RegistrationExpirySearchPage />}
        />
      </Routes>
    </>
  );
};

FleetRegistrationRouter.route =
  FleetRegistrationRoutes.FleetRegistrationRouter;

export default FleetRegistrationRouter;
